const API_VERSION_PARAM = "api-version";
const isIApiError = (error) => {
  const e = error;
  return e.code !== void 0 && e.message !== void 0;
};
const isIApiErrorWithContext = (error) => isIApiError(error) && error.errorContext !== void 0;
const isWorkspacePayload = (payload) => payload.workspaceId !== void 0;
const isEntityIdPayload = (payload) => payload.id !== void 0;
const isNestedEntityIdPayload = (payload) => payload.secondaryId !== void 0;
const isEntityPayload = (payload) => payload.entity !== void 0;
const isQueryPayload = (payload) => payload.query !== void 0;
export {
  API_VERSION_PARAM,
  isEntityIdPayload,
  isEntityPayload,
  isIApiError,
  isIApiErrorWithContext,
  isNestedEntityIdPayload,
  isQueryPayload,
  isWorkspacePayload
};
//# sourceMappingURL=types.js.map
